module.exports = __webpack_public_path__ + "img/logo_mini.e8cc56c5.jpg";